// extracted by mini-css-extract-plugin
export var hero = "index-module--hero--3y8uL";
export var descText = "index-module--descText--1Znck";
export var dakarimages = "index-module--dakarimages--2e2Db";